import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  InputAdornment,
  Divider,
} from "@mui/material";
import backgroundImg from "../../assets/login_bg.png";
import logo from "../../assets/logo.png";
import logo2 from "../../assets/DaalchiniLogo.png";
import gift_logo from "../../assets/gift_logo.png";
import GoogleLogin from "react-google-login";
import WaitingLoader from '../../Loader/component'
import { useLocation, useNavigate } from "react-router-dom";

function PhoneNumberPage({
 
  handleAuthenticate,

  setMobileNo,
  mobileNo,
  
  onGoogleSuccess,
  onGoogleFailure,
 
  handleSkipLogin,
  
  loader,
  isButtonDisabled
}) {
  // Common Styles
  const fixedButtonStyle = {
    position: "fixed",
    borderRadius: "27px",
    background: "rgba(0,0,0,0.62)",
    color: "#FFF",
    textAlign: "center",
    fontFamily: "Roboto",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "28px",
    padding: "5px 10px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
  };
let route;
  const location = useLocation()
  const navigate=useNavigate()
  const params = new URLSearchParams(location.search);



const url = params.get("route");

let   tagOrderId = null;

if (url && url.includes("value=")) {
    tagOrderId = url.split("value=")[1];
}

//console.log("value---",  tagOrderId,);


  const support = params.get("support");  // "true"
  if(support){

   route="/help&support"
    // console.log("route-----",route)
  }

  else{
    route = params.get("route");
      //console.log("route",route)
  }

 
  const GuestBack=()=>{
navigate(`/`)

  }

  
  return (
    <Box
      sx={{
        minHeight: "100vh",
        maxHeight: "100vh",
        backgroundImage: `url(${backgroundImg})`,
        backgroundSize: "cover",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 2,
        position: "relative",
      }}
    >
      {loader && <WaitingLoader />}

      {/* Guest Back Button */}
      {localStorage.getItem("Guest_clientId") && (
        <Box sx={{ ...fixedButtonStyle, top: 62, left: 25 }} onClick={GuestBack}>
          Back
        </Box>
      )}

      {/* Skip Button */}
      {!tagOrderId && !localStorage.getItem("Guest_clientId") && (
        <Box sx={{ ...fixedButtonStyle, top: 25, right: 20 ,height:"15px",padding:"15px"}} onClick={handleSkipLogin}>
          Skip
        </Box>
      )}

      {/* Brand Logo */}
      <Box
        component="img"
        src={logo2}
        alt="Brand Logo"
        sx={{
          position: "absolute",
          top: 20,
          left: 25,
          width: 80,
          height: "auto",
          zIndex: 10,
        }}
      />

      {/* Main Container */}
      <Box
        sx={{
          width: { xs: "100%", sm: 400 },
          maxWidth: "100%",
          bgcolor: { xs: "transparent", sm: "white" },
          borderRadius: 2,
          boxShadow: { xs: "none", sm: 3 },
          textAlign: "center",
          p: { xs: 0, sm: 4 },
          pt: { xs: 0, sm: 2 },
          mt: { xs: 0, sm: "-25vw" },
          marginTop: { xs: "-25vw", sm: "-25vw" },
        }}
      >
        {/* Main Logo */}
        <Box display="flex" justifyContent="center">
          <Box
            component="img"
            src={tagOrderId ? gift_logo : logo}
            alt="Main Logo"
            sx={{
              width: tagOrderId ? 230 : 100,
              height: tagOrderId ? 230 : 100,
              mb: tagOrderId ? 0 : 3,
            }}
          />
        </Box>

        {/* Title */}
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {tagOrderId ? (
            <span>
              Unlock Surprise <br />
              Coupons Now
            </span>
          ) : (
            <span>
              India's First 24×7 Instant <br /> Automated Store
            </span>
          )}
        </Typography>

        {/* Subtitle */}
        {!tagOrderId && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Please enter your phone number to login<br /> or create an account.
          </Typography>
        )}

        {/* Divider */}
        <Divider sx={{ my: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>
            Login
          </Typography>
        </Divider>

        {/* Phone Input */}
        <TextField
            fullWidth
        placeholder="Enter mobile number"
        value={mobileNo}
        onChange={(e) => setMobileNo(e.target.value)}
        inputProps={{ maxLength: 10 }}
       
          sx={{
            mb: 2,
            backgroundColor: "white",
            borderRadius: 1,
            boxShadow: "0 -1px 7px rgb(0 0 0 / 20%)",
            "& .MuiInputBase-input": { paddingLeft: "10px" },
          }}
          InputProps={{
            type: "tel",
            inputMode: "numeric",
            startAdornment: (
              <InputAdornment position="start">
                <Box
                  component="img"
                  src="https://flagcdn.com/w20/in.png"
                  alt="India"
                  sx={{ width: 24, mr: 1 }}
                />
                <Typography variant="body1">+91</Typography>
              </InputAdornment>
            ),
          }}
        />

        {/* Continue Button */}
           
  

      <Button
        fullWidth
        variant="contained"
        sx={{
          bgcolor: !isButtonDisabled ? "#00B177" : "#ccc",
          color: "white",
          fontWeight: "bold",
          mb: 2,
          p: 2,
          "&:hover": {
            bgcolor: !isButtonDisabled ? "#00a166" : "#ccc",
          },
        }}
        onClick={handleAuthenticate}
        disabled={isButtonDisabled}
      >
        CONTINUE
      </Button>
    

        {/* Optional Order Info */}
        {tagOrderId && (
          <Typography variant="body1" color="#B96D16">
            Log in to see your gifts & Coupons
          </Typography>
        )}

        {/* Google Login */}
        {!tagOrderId && (
          <GoogleLogin
            clientId="79634458363-nhi15g8c5sdoa24bm8pp5c0ooc4fps7i.apps.googleusercontent.com"
            onSuccess={onGoogleSuccess}
            onFailure={onGoogleFailure}
            cookiePolicy="single_host_origin"
            render={(renderProps) => (
              <button
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}
                style={{
                  textAlign: "center",
                  padding: "4.8%",
                  border: "2px solid #80808087",
                  borderRadius: "5px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {/* Google Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.64 9.20443C17.64 8.56625 17.5827 7.95262 17.4764 7.36353H9V10.8449H13.8436C13.635 11.9699 13.0009 12.9231 12.0477 13.5613V15.8194H14.9564C16.6582 14.2526 17.64 11.9453 17.64 9.20443Z"
                    fill="#4285F4"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 18C11.43 18 13.4673 17.1941 14.9564 15.8195L12.0477 13.5613C11.2418 14.1013 10.2109 14.4204 9 14.4204C6.65591 14.4204 4.67182 12.8372 3.96409 10.71H0.957275V13.0418C2.43818 15.9831 5.48182 18 9 18Z"
                    fill="#34A853"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.96409 10.7101C3.78409 10.1701 3.68182 9.59325 3.68182 9.00007C3.68182 8.40689 3.78409 7.83007 3.96409 7.29007V4.95825H0.957273C0.347727 6.17325 0 7.5478 0 9.00007C0 10.4523 0.347727 11.8269 0.957273 13.0419L3.96409 10.7101Z"
                    fill="#FBBC05"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M9 3.57955C10.3214 3.57955 11.5077 4.03364 12.4405 4.92545L15.0218 2.34409C13.4632 0.891818 11.4259 0 9 0C5.48182 0 2.43818 2.01682 0.957275 4.95818L3.96409 7.29C4.67182 5.16273 6.65591 3.57955 9 3.57955Z"
                    fill="#EA4335"
                  />
                </svg>
                <span style={{ marginLeft: "5%" }}>Log in with Google</span>
              </button>
            )}
          />
        )}

        {/* Footer */}
        <Box
          sx={{
            position: "absolute",
            width: "100%",
            bottom: { xs: "10px", sm: "100px" },
            left: 0,
            textAlign: "center",
          }}
        >
          <Typography variant="caption" color="text.secondary">
            By continuing, you agree to our{" "}
            <a
              href="https://www.daalchini.co.in/terms.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "none", fontSize: 12 }}
            >
              Terms of Service
            </a>{" "}
            and{" "}
            <a
              href="https://www.daalchini.co.in/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", textDecoration: "none", fontSize: 12 }}
            >
              Privacy Policy
            </a>
            .
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default PhoneNumberPage;
